import Button from "@/components/ui/button";
import Icon from "@components/ui/icon";
import { MediaLibDialogBase } from "@editor/modules/media-lib";
import { useAppDispatch } from "@store";
import { closeDialog } from "@store/dialogs";

const DIALOG_ID = "media-lib-website-copyright";

interface IProps {
  onSubmit: () => void;
  setIsImportingWebsite: (value: boolean) => void;
  websiteUrl: string | null;
  setWebsiteUrl: (value: string | null) => void;
}

export const MediaLibWebsiteCopyrightDialog = ({
  onSubmit,
  setIsImportingWebsite,
  websiteUrl,
  setWebsiteUrl,
}: IProps) => {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(closeDialog(DIALOG_ID));
    setIsImportingWebsite(false);
    setWebsiteUrl("");
  };

  const handleSubmit = () => {
    setIsImportingWebsite(true);
    dispatch(closeDialog(DIALOG_ID));
    onSubmit();
  };

  return (
    <MediaLibDialogBase>
      <MediaLibDialogBase.Header
        title="Copyrights disclaimer"
        onClose={handleClose}
      />
      <MediaLibDialogBase.Content className="tw-w-[624px]">
        <div className="tw-flex tw-rounded tw-border tw-border-solid tw-border-[#FFB82E] tw-bg-[#FFB82E]/20 tw-px-3 tw-py-4">
          <Icon
            icon="ri-alert-fill"
            className="tw-mr-2 tw-text-2xl/none tw-text-[#FFB82E]"
          />
          <div className="tw-text-[11px]">
            I approve that I have the right to use content extracted from this
            website: {websiteUrl} I acknowledge that Storydoc has no rights to
            use my content, nor can it be held responsible for any violation of
            copyrights, privacy, or applicable law.
            <br />
            To learn more see our{" "}
            <a
              href="https://www.storydoc.com/terms-and-co"
              target="_blank"
              rel="noopener noreferrer"
              className="tw-font-semibold tw-text-primary tw-underline visited:tw-text-primary active:tw-text-primary"
            >
              Terms and Conditions
            </a>
          </div>
        </div>
      </MediaLibDialogBase.Content>
      <MediaLibDialogBase.Footer>
        <Button variant="secondary" className="tw-mr-4" onClick={handleClose}>
          Decline and go back
        </Button>
        <Button onClick={handleSubmit}>Accept and continue</Button>
      </MediaLibDialogBase.Footer>
    </MediaLibDialogBase>
  );
};

MediaLibWebsiteCopyrightDialog.dialogId = DIALOG_ID;
